var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(
      _vm.rule &&
        _vm.rule.customContractValidationContents &&
        _vm.rule.customContractValidationContents.length &&
        ((_vm.isEmpty && _vm.rule.validationType != 1) || _vm.rule.validationType == 2)
    )?_c('div',{class:{
      hintLabel: _vm.rule.validationType == 2,
      requiredLabel: _vm.rule.validationType == 3,
      warningLabel: _vm.rule.validationType == 4,
    }},[_vm._v("\n    "+_vm._s(_vm.rule.customContractValidationContents[0].value)+"\n  ")]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }